import styled, { css } from 'styled-components'
import { device, fonts, colors } from 'stylesheets'

const Bold = css`
  font-weight: bold;
`;

export const Content = styled.div`
  display: block;
  text-align: -webkit-center;
  min-height: 400px;
  padding: 0 60px 0;
`

export const Title = styled.div`
  font-family: ${colors.primary};
  font-weight: 500;
  font-size: 13px;
  display: flex;
  justify-content: center;
  text-align: center;
  margin-bottom: 10px;
  margin-top: 20px;
`

export const SubTitle = styled.strong`
  font-family: ${colors.secondary};
  font-weight: normal;
  font-size: 13px;
  display: flex;
  justify-content: center;
  text-align: center;
  white-space: nowrap;
`

export const Image = styled.img`
  height: 100%;
  margin: 0 auto;
  margin-top: 10px;
`
